import React, { Fragment, useCallback, useEffect, useState } from "react";
import "./Prototype.css";
import BarcodeScannerComponent from "react-qr-barcode-scanner";

import {
  Container,
  Grid,
  Typography,
  Divider,
  Button,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Collapse,
  Card,
  CardMedia,
  CardContent,
  Checkbox,
  Tooltip,
  IconButton,
  Fab,
  TextField,
  InputAdornment,
  CircularProgress,
  Select,
  MenuItem,
  Input,
  InputLabel,
} from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
// import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TableRowsIcon from "@mui/icons-material/TableRows";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import SaveIcon from "@mui/icons-material/Save";

import { useLocation } from "react-router-dom";

import { backend, API_URL } from "../../config";

import { useSelector } from "react-redux";

import Subitems from "../Dialogs/Subitems/Subitems";

const columnsPrototype = [
  {
    id: "picked",
    label: "Picked",
    minWidth: 1,
    align: "center",
    exposed: true,
    exposedAs: "checkbox",
  },
  {
    id: "scanned",
    label: "Scanned",
    minWidth: 1,
    align: "center",
    exposed: true,
    exposedAs: "checkbox",
  },
  {
    id: "unit_quantity",
    label: "Unit Needed",
    minWidth: 1,
    align: "center",
    exposed: false,
    exposedAs: "input",
  },
  {
    id: "units_ordered",
    label: "Units Ordered",
    minWidth: 1,
    align: "center",
    exposed: false,
    exposedAs: "input",
  },
  {
    id: "case_quantity",
    label: "Case Needed",
    minWidth: 1,
    align: "center",
    exposed: false,
    exposedAs: "input",
  },
  {
    id: "cases_ordered",
    label: "Cases Ordered",
    minWidth: 1,
    align: "center",
    exposed: false,
    exposedAs: "input",
  },
  {
    id: "bin",
    label: "Bin",
    minWidth: 1,
    align: "center",
  },
  {
    id: "upc",
    label: "UPC",
    minWidth: 2,
    align: "center",
  },
  {
    id: "name",
    label: "Item Name",
    minWidth: true,
    align: "center",
    exposed: false,
    exposedAs: "select",
  },
  {
    id: "url",
    label: "Image",
    minWidth: "auto",
    align: "center",
  },
  {
    id: "order",
    label: "Order",
    minWidth: 1,
    align: "center",
  },
];

const imageTypes = [".jpg", ".jpeg", ".png"];

const Prototype = (props) => {
  const location = useLocation();

  // todo: sortingState and filterState prop is being sent but not used atm
  const { bulkState, dateRangeState, ordersState } = location.state;

  const currentUserStore = useSelector((state) => state.current_user);

  const [barcode, setBarcode] = useState(""); // "0019607248883"); // "0020600594341"); // ""
  const [barcodeScanned, setBarcodeScanned] = useState(false); // false
  const [barcodeInfo, setBarcodeInfo] = useState(null);
  const [barcodeInfoLoaded, setBarcodeInfoLoaded] = useState(false);
  const [itemFound, setItemFound] = useState(null);
  const [asItemsFound, setAsItemsFound] = useState(null);
  const [itemToSwap, setItemToSwap] = useState(null);
  const [itemSwapped, setItemSwapped] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [orderItems, setOrderItems] = useState([]);
  const [orderItemsMapped, setOrderItemsMapped] = useState(false);
  const [orderSubItems, setOrderSubItems] = useState([]);
  const [orderSubItemsLoaded, setOrderSubItemsLoaded] = useState(false);
  const [orderItemsPos, setOrderItemsPos] = useState(0);
  const [orderItemsMatched, setOrderItemsMatched] = useState([]);
  const [orderItemsMatchedFinish, setOrderItemsMatchedFinish] = useState(false);
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [scanDialog, setScanDialog] = useState(false);
  const [showPicked, setShowPicked] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [responseModal, setResponseModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [imageInfo, setImageInfo] = useState({
    column: "image",
    row: {
      image:
        "https://images.freeimages.com/images/large-previews/fc3/surgeon-1-1562057.jpg",
    },
    name: "A default product",
  });
  const [view, setView] = useState(1);
  const [itemToLink, setItemToLink] = useState(null);

  const paginate = (arr, size) => {
    return arr.reduce((acc, val, i) => {
      let idx = Math.floor(i / size);
      let page = acc[idx] || (acc[idx] = []);
      page.push(val);

      return acc;
    }, []);
  };

  const infraInputSubmit = (e) => {
    e.preventDefault();

    const value = document.getElementById("infraInput").value;

    handleScan(null, { text: value });
  };

  const handleScan = (err, result) => {
    if (!result) {
      setBarcode("Not found");
      setBarcodeScanned(false);
    } else {
      setBarcode(result.text);
      setBarcodeScanned(true);
    }
  };

  const orderPickupFormatting = () => (
    <>
      {orderItemsMatchedFinish ? (
        orderItemsMatched.length ? (
          !asItemsFound ? (
            <>
              {orderItemsMatched.map((item, idx) => (
                <Fragment key={idx}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={12}>
                      <Card>
                        <CardMedia
                          component="img"
                          width="150"
                          height="150"
                          image={item.url}
                          alt={item.name}
                        />
                        <CardContent>
                          <Typography gutterBottom variant="h5" component="div">
                            {item.name}
                            <Subitems
                              data={item}
                              handleSubitemsChange={handleSubitemsChange}
                            />
                          </Typography>
                          <Typography color="text.secondary" variant="h5">
                            <b>{`${item.unit_quantity} of ${item.units_ordered}`}</b>
                            {` units needed`}
                          </Typography>
                          <Typography color="text.secondary" variant="h5">
                            <b>{`${item.case_quantity} of ${item.cases_ordered}`}</b>
                            {` cases needed`}
                          </Typography>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={12}></Grid>
                            <Grid item xs={2} sm={2}>
                              <b>Units</b>
                            </Grid>
                            <Grid item xs={10} sm={10}>
                              <IconButton
                                disabled={item.units_ordered === 0}
                                onClick={(e) =>
                                  item.unit_quantity === 0
                                    ? e.preventDefault()
                                    : handleChangeMatched({
                                        target: {
                                          checked: false,
                                          name: `unit_quantity-${idx}`,
                                          value: +item.unit_quantity - 1,
                                        },
                                      })
                                }
                              >
                                <RemoveIcon
                                  color={
                                    item.units_ordered === 0
                                      ? "disabled"
                                      : "error"
                                  }
                                />
                              </IconButton>
                              <TextField
                                size="small"
                                type="number"
                                disabled={item.units_ordered === 0}
                                variant="outlined"
                                label="Units: "
                                name={`units_ordered-${idx}`}
                                InputProps={{
                                  inputProps: { min: 0 },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <b>picked</b>
                                    </InputAdornment>
                                  ),
                                }}
                                value={item.unit_quantity}
                                onChange={(e) => handleChangeMatched(e)}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+" ||
                                    event?.key === "."
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                                style={{ width: 150 }}
                              />
                              <IconButton
                                disabled={item.units_ordered === 0}
                                onClick={() =>
                                  handleChangeMatched({
                                    target: {
                                      checked: false,
                                      name: `unit_quantity-${idx}`,
                                      value: +item.unit_quantity + 1,
                                    },
                                  })
                                }
                              >
                                <AddIcon
                                  color={
                                    item.units_ordered === 0
                                      ? "disabled"
                                      : "success"
                                  }
                                />
                              </IconButton>
                            </Grid>
                            <Grid item xs={2} sm={2}>
                              <b>Cases</b>
                            </Grid>
                            <Grid item xs={10} sm={10}>
                              <IconButton
                                disabled={item.cases_ordered === 0}
                                onClick={(e) =>
                                  item.case_quantity === 0
                                    ? e.preventDefault()
                                    : handleChangeMatched({
                                        target: {
                                          checked: false,
                                          name: `case_quantity-${idx}`,
                                          value: +item.case_quantity - 1,
                                        },
                                      })
                                }
                              >
                                <RemoveIcon
                                  color={
                                    item.cases_ordered === 0
                                      ? "disabled"
                                      : "error"
                                  }
                                />
                              </IconButton>
                              <TextField
                                size="small"
                                type="number"
                                disabled={item.cases_ordered === 0}
                                variant="outlined"
                                label="Cases: "
                                name={`case_quantity-${idx}`}
                                InputProps={{
                                  inputProps: { min: 0 },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <b>picked</b>
                                    </InputAdornment>
                                  ),
                                }}
                                value={item.case_quantity}
                                onChange={(e) => handleChangeMatched(e)}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+" ||
                                    event?.key === "."
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                                style={{ width: 150 }}
                              />
                              <IconButton
                                disabled={item.cases_ordered === 0}
                                onClick={() =>
                                  handleChangeMatched({
                                    target: {
                                      checked: false,
                                      name: `case_quantity-${idx}`,
                                      value: +item.case_quantity + 1,
                                    },
                                  })
                                }
                              >
                                <AddIcon
                                  color={
                                    item.cases_ordered === 0
                                      ? "disabled"
                                      : "success"
                                  }
                                />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Fragment>
              ))}
            </>
          ) : (
            <>
              There are no items in the order with the scanned barcode.
              <br />
              <br />
              However we found an item with an acceptable substitution that
              matchs with the scanned barcode.
              <br />
              <br />
              <Typography gutterBottom variant="h5" component="div">
                {`${asItemsFound.name} (${asItemsFound.upc})`}
              </Typography>
              <br />
              Do you want to swap this item?
            </>
          )
        ) : (
          <>
            There are no items in the order with the scanned barcode. <br />
            <br />
            {currentUserStore ? (
              currentUserStore.role_id === 14 || currentUserStore.is_staff ? (
                !barcodeInfo ? (
                  <>
                    <b>
                      Please re-scan or link this barcode to a product included
                      in the scanning list using the interface below:
                    </b>
                    <br />
                    <br />
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={true}>
                        <InputLabel shrink id="ItemLinkLabel">
                          Item to Link
                        </InputLabel>
                        <Select
                          fullWidth
                          input={<Input />}
                          name="item-link"
                          onChange={handleChangeITL}
                          value={itemToLink || ""}
                        >
                          {orderItems.map((item, idx) => (
                            <MenuItem key={`orderItem_${idx}`} value={item}>
                              {`${item.name} (${item.upc})`}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item xs={"auto"}>
                        <Button
                          color="info"
                          variant="contained"
                          disabled={!itemToLink}
                          onClick={() => sendRequestPTL()}
                        >
                          Link
                        </Button>
                      </Grid>
                      {itemToLink && itemToLink.alternate_barcodes.length ? (
                        <>
                          <Grid item xs={12}>
                            The selected item already has some barcodes linked:
                          </Grid>
                          {itemToLink.alternate_barcodes.map((altbar, idx) => (
                            <Fragment key={`altbar-${idx}`}>
                              <Grid item xs={true} style={{ paddingTop: 0 }}>
                                <b>{altbar}</b>
                              </Grid>
                              <Grid item xs={"auto"} style={{ paddingTop: 0 }}>
                                <Button
                                  color="info"
                                  variant="contained"
                                  onClick={() => sendRequestBTD(altbar, true)}
                                >
                                  UnLink
                                </Button>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                style={{ paddingTop: 8 }}
                              ></Grid>
                            </Fragment>
                          ))}
                        </>
                      ) : (
                        <></>
                      )}
                    </Grid>
                  </>
                ) : (
                  <>
                    <b>
                      Additionally, the detected barcode is already linked to an
                      item, if you would like to unlink the barcode use the
                      interface below:
                    </b>
                    <br />
                    <br />
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={true}>
                        UPC: <b>{` ${barcodeInfo.product}`}</b>
                      </Grid>
                      <Grid item xs={"auto"}>
                        <Button
                          color="info"
                          variant="contained"
                          onClick={() =>
                            sendRequestBTD(barcodeInfo.barcode, false)
                          }
                        >
                          UnLink
                        </Button>
                      </Grid>
                    </Grid>
                  </>
                )
              ) : (
                <>
                  <b>Please re-scan</b>
                </>
              )
            ) : (
              <></>
            )}
          </>
        )
      ) : (
        <>
          <div align="center">
            <CircularProgress />
            <div>Searching</div>
          </div>
        </>
      )}
    </>
  );

  const orderPickupConfirming = () => {
    let barcodeModified = "";
    setOrderItems((prevState) => {
      let itemIndex = prevState.findIndex((item) => `${item.upc}` === barcode);

      if (itemIndex === -1) {
        barcodeModified = +barcode; // stripped leading 0s

        barcodeModified = barcodeModified
          .toString()
          .substring(0, barcodeModified.toString().length - 1);

        itemIndex = prevState.findIndex(
          (item) => item.upc === +barcodeModified
        );

        if (itemIndex === -1) {
          barcodeModified = barcodeModified
            .toString()
            .substring(1, barcodeModified.length); // stripping first digit of remaining barcodeF

          barcodeModified = +barcodeModified; // stripped leading 0s

          itemIndex = prevState.findIndex(
            (item) => item.upc === +barcodeModified
          );

          // loop orderitems and look up in the barcode identifiers (alternatives)
          if (itemIndex === -1) {
            itemIndex = prevState.findIndex((item) =>
              !item.alternate_barcodes.length
                ? false
                : item.alternate_barcodes.includes(barcode)
            );
          }
        }
      }

      if (itemIndex !== -1) {
        prevState[itemIndex].modified = true;
        prevState[itemIndex].scanned = true;
      }

      return prevState;
    });

    setItemFound(() =>
      orderItems.find(
        (item) =>
          item.upc === (barcodeModified === "" ? barcode : +barcodeModified)
      )
    );

    scanReset();
  };

  const scanReset = () => {
    setBarcode("");
    setBarcodeScanned(false);
    setBarcodeInfo(null);
    setBarcodeInfoLoaded(false);
    setItemSwapped(false);
    setItemToLink(null);
    setOrderItemsMatched([]);
    setOrderItemsMatchedFinish(false);
  };

  const orderSwapConfirming = () => {
    setOrderItems((prevState) => {
      let itemIndex = prevState.findIndex(
        (item) => item.upc === itemToSwap.upc
      );

      if (itemIndex !== -1) {
        prevState[itemIndex] = {
          ...prevState[itemIndex],
          ...asItemsFound,
          original_product: itemToSwap.upc,
          product: asItemsFound.upc,
          unit_quantity: 0,
          case_quantity: 0,
          scanned: null,
          modified: true,
        };
      }

      return prevState;
    });
    setAsItemsFound(null);
    setItemToSwap(null);
    setItemSwapped(true);
  };

  const handleSubitemsChange = (upc, subitems) => {
    setOrderItems((prevState) =>
      prevState.map((item) => {
        if (item.upc !== upc) return item;

        const totalLbs = subitems.reduce(
          (previous, current) => previous + current.weight_lbs,
          0
        );

        const price =
          subitems[0].unit_type === "u"
            ? item.display_unit_price
            : item.display_case_price;

        const totalNew = price * totalLbs;

        return {
          ...item,
          subitems: subitems,
          estimated_price: totalNew.toFixed(2),
        };
      })
    );
  };

  const handleChange = (e) => {
    const { checked, name, value, ffSkip = false } = e.target;
    const [columnId, rowId] = name.split("-");
    const columnData = columnsPrototype.find((item) => item.id === columnId);
    const isEvent = e.hasOwnProperty("type");

    setOrderItems((prevState) =>
      prevState.map((item, index) => {
        if (+rowId === index) {
          const columnValue = columnData.hasOwnProperty("exposedAs")
            ? columnData.exposedAs === "checkbox"
              ? checked
              : value
            : value;

          if (isEvent && columnId === "scanned") {
            item.scanned = columnValue === false ? null : false;
          } else if (isEvent && columnId === "picked") {
            item.scanned = columnValue === false ? null : true;
          } else {
            item[columnId] = columnValue;
          }

          item["modified"] = true;

          return item;
        } else {
          return item;
        }
      })
    );

    if (ffSkip) {
      setOrderItemsPos((prevState) => {
        const itemsToPick = orderItems.filter((item) => item.scanned === null);
        const nextPos = prevState + 1;

        return nextPos <= itemsToPick.length - 1 ? nextPos : 0;
      });
    }
  };

  const handleChangeMatched = (e) => {
    const { name, value } = e.target;
    const [columnId, rowId] = name.split("-");

    setOrderItemsMatched((prevState) =>
      prevState.map((item, index) => {
        if (+rowId === index) {
          item[columnId] = value;
          item["modified"] = true;
          return item;
        } else {
          return item;
        }
      })
    );
  };

  const handleChangeView = () =>
    setView((prevState) => (prevState === 1 ? 2 : 1));

  const handleChangeOIPos = (upc) => {
    const itemToPickPosInOI = orderItems
      .filter((item) => item.scanned === null)
      .findIndex((item) => item.upc === upc);

    setOrderItemsPos(itemToPickPosInOI);
    toggleScanDialog();
  };

  const handleChangeITL = (e) => {
    const { value } = e.target;

    setItemToLink(value);
  };

  const toggleShowPicked = () => setShowPicked(!showPicked);

  const toggleScanDialog = () => setScanDialog(!scanDialog);

  const toggleImageModal = () => setImageModal(!imageModal);

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const toggleResponseModal = () => setResponseModal(!responseModal);

  const itemToPickFormat = () => {
    if (!orderItems.length) return <></>;

    const itemsToPick = orderItems.filter((item) => item.scanned === null);

    if (!itemsToPick.length) return <></>;

    const itemPosition =
      orderItemsPos > itemsToPick.length - 1
        ? itemsToPick.length
        : orderItemsPos;

    const itemToPick = itemsToPick[itemPosition];

    const itemToPickPosInOI = orderItems.findIndex(
      (item) => item.upc === itemToPick.upc
    );

    return itemToPick.hasOwnProperty("upc") ? (
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6}>
          <Card>
            <CardMedia
              component="img"
              width="150"
              height="150"
              image={itemToPick.url}
              alt={itemToPick.name}
            />
          </Card>
        </Grid>
        <Grid item xs={6} sm={6}>
          <div style={{ textAlign: "right", marginBottom: 8 }}>
            <Subitems
              data={itemToPick}
              handleSubitemsChange={handleSubitemsChange}
            />
            <Button
              variant="contained"
              size="small"
              color={itemToPick.scanned === false ? "warning" : "inherit"}
              onClick={() =>
                handleChange({
                  target: {
                    name: `scanned-${itemToPickPosInOI}`,
                    checked: itemToPick.scanned === false ? null : false,
                    ffSkip: true,
                  },
                })
              }
            >
              Scanned
            </Button>
            <Button
              variant="contained"
              size="small"
              color={itemToPick.scanned ? "success" : "inherit"}
              onClick={() =>
                handleChange({
                  target: {
                    name: `scanned-${itemToPickPosInOI}`,
                    checked: itemToPick.scanned ? null : true,
                  },
                })
              }
              style={{ marginLeft: 8 }}
            >
              Picked
            </Button>
          </div>
          <Button
            variant="contained"
            color="info"
            size="small"
            onClick={() =>
              setOrderItemsPos((prevState) => {
                const nextPos = prevState + 1;

                return nextPos <= itemsToPick.length - 1 ? nextPos : 0;
              })
            }
            style={{ float: "right", marginLeft: 10 }}
          >
            Skip
          </Button>
          <Typography
            color="text.secondary"
            variant="h6"
            fontWeight="400"
          >{`${itemToPick.upc}`}</Typography>
          <Typography gutterBottom variant="h5" component="div">
            {itemToPick.name}
          </Typography>
          <Typography
            color="text.secondary"
            variant="h6"
            fontWeight="400"
            style={{ margin: 0 }}
          >
            {`Bin: `}
            <b>{`${itemToPick.bin}`}</b>
          </Typography>
          <Typography
            color="text.secondary"
            variant="h6"
            fontWeight="400"
            style={{ margin: 0 }}
          >
            {` Order: `}
            <b>{`${itemToPick.order}`}</b>
          </Typography>
          <Typography
            color="text.secondary"
            variant="h6"
            fontWeight="400"
            style={{ margin: 0 }}
          >
            {` Inventory Stock: `}
            <b>{`${itemToPick.stock_level || "N/A"}`}</b>
          </Typography>
          <Typography
            color="text.secondary"
            variant="h6"
            fontWeight="400"
            style={{ margin: 0 }}
          >
            {` Combined Stock: `}
            <b>{`${itemToPick.combined_stock_level || "N/A"}`}</b>
          </Typography>
          <Typography variant="h6" fontWeight="400" color="text.secondary">
            {`${itemToPick.unit_quantity} of ${itemToPick.units_ordered} units needed`}
          </Typography>
          <Typography variant="h6" fontWeight="400" color="text.secondary">
            {`${itemToPick.unit_quantity} of ${itemToPick.cases_ordered} cases needed`}
          </Typography>
        </Grid>
      </Grid>
    ) : (
      <></>
    );
  };

  const scanDialogContent = (
    <Box
      component="form"
      noValidate
      autoComplete="off"
      onSubmit={infraInputSubmit}
    >
      <DialogTitle>Scanning</DialogTitle>
      <DialogContent>
        {barcode === "" || barcode === "Not found" ? (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <TextField
                autoFocus
                id="infraInput"
                name="infraInput"
                fullWidth
                size="small"
                variant="standard"
                type="text"
                inputProps={{
                  inputMode: "none",
                }}
              />
              <BarcodeScannerComponent
                onUpdate={(err, result) => handleScan(err, result)}
                stopStream={barcodeScanned}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              {itemToPickFormat()}
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              {`APP Detected barcode: ${barcode}`}
            </Grid>
            <Grid item xs={12} sm={12}>
              {orderPickupFormatting()}
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            scanReset();
            toggleScanDialog();
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={!barcodeScanned}
          variant="contained"
          color="inherit"
          onClick={scanReset}
        >
          Re-scan
        </Button>
        {!asItemsFound ? (
          <Button
            disabled={!barcodeScanned}
            variant="contained"
            color="success"
            onClick={orderPickupConfirming}
          >
            Next
          </Button>
        ) : (
          <Button
            disabled={!barcodeScanned}
            variant="contained"
            color="info"
            onClick={orderSwapConfirming}
          >
            Swap
          </Button>
        )}
      </DialogActions>
    </Box>
  );

  const imageModalContent = (
    <Box component="form" noValidate autoComplete="off">
      <DialogContent align="center">
        <img
          alt={
            imageInfo["row"]["name"]
              ? imageInfo["row"]["name"]
              : imageInfo["name"]
          }
          src={imageInfo["row"][imageInfo["column"]]}
          width="100%"
          height="auto"
        />
        <div>
          {imageInfo["row"]["name"]
            ? imageInfo["row"]["name"]
            : imageInfo["name"]}
        </div>
      </DialogContent>
    </Box>
  );

  const confirmModalContent = (
    <Box component="form" noValidate autoComplete="off">
      <DialogContent>
        Are you sure you want to save the Scan changes?
      </DialogContent>
      <DialogActions>
        <Button onClick={() => toggleConfirmModal()}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => sendRequest()}
        >
          Confirm
        </Button>
      </DialogActions>
    </Box>
  );

  const responseModalContent = (
    <Box>
      <DialogContent>
        {errorInfo.error ? (
          <>
            There was an error saving the Scan changes
            <br />
            <br />
            <span
              style={{
                color: "red",
                wordBreak: "break-word",
                maxHeight: 160,
                overflow: "hidden",
                display: "inline-block",
              }}
            >
              <b>Error:</b>
              <br />
              {errorInfo.message}
            </span>
          </>
        ) : (
          <>Changes to the Scan has been successfully saved</>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => toggleResponseModal()}
        >
          Continue
        </Button>
      </DialogActions>
    </Box>
  );

  const sendRequest = useCallback(
    (silence = false) => {
      console.log("saving changes");
      setIsSaving(true);

      if (!silence) {
        // toggleConfirmModal();
        setConfirmModal(false);
      }

      Promise.all(
        orderItems.map(async (item) => {
          if (item.modified && !item.new) {
            const oiModified = {
              admin_added: item.admin_added,
              case_quantity: item.case_quantity,
              cases_ordered: item.cases_ordered,
              coupon_amount: item.coupon_amount,
              coupon_note: item.coupon_note,
              estimated_price: item.estimated_price,
              final_price: item.final_price,
              id: item.id,
              order: item.order,
              original_product: item.original_product,
              price_snapshot: item.price_snapshot,
              product: item.product,
              taxable: item.taxable,
              unit_quantity: item.unit_quantity,
              units_ordered: item.units_ordered,
              scanned: item.scanned,
            };

            await backend
              .patch(`${API_URL}orderitems/${item.id}`, oiModified)
              .then(() => {
                item.modified = false;
                item.new = false;
              })
              .catch((error) => {
                console.log(error);
                setErrorInfo(error);
                setResponseModal(true);
              });
          }

          return item;
        })
      ).then((result) => {
        setOrderItems(result);
        setIsSaving(false);

        if (!silence) {
          // toggleResponseModal();
          setResponseModal(true);
        }
      });
    },
    [orderItems]
  );

  /* const resolveRequest = () => {
    props.history.push("/orders");
  }; */

  const getImageComponent = (column, row) => {
    const value = row[column.id];

    const isImg = imageTypes.some((itype) =>
      value.toLocaleLowerCase().indexOf(itype)
    );

    if (!isImg) {
      return value;
    }

    const dirs = value.split("/");
    const filename = dirs.pop();
    const imgInfo = {
      column: column.id,
      name: filename,
      row: row,
    };

    const displayImageComp = (
      <Tooltip title="View image">
        <IconButton
          aria-label="view image"
          onClick={() => {
            setImageInfo(imgInfo);
          }}
        >
          <OpenInNewIcon />
        </IconButton>
      </Tooltip>
    );

    return displayImageComp;
  };

  const sendRequestPTL = async () => {
    console.log(itemToLink, barcode, barcodeScanned);

    const barcodeIdentifierObj = {
      barcode: barcode,
      product: itemToLink.upc,
    };

    await backend
      .post(`${API_URL}barcodealternates/`, barcodeIdentifierObj)
      .then(({ data }) => {
        if (data.hasOwnProperty("product")) {
          setOrderItems((prevState) =>
            prevState.map((item) => {
              if (item.upc !== data.product) return item;

              const barcodeIdentifiersMap = [
                ...item.alternate_barcodes,
                data.barcode,
              ];

              return { ...item, alternate_barcodes: barcodeIdentifiersMap };
            })
          );
        }

        scanReset();
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo(error);
        // toggleResponseModal();
        setResponseModal(true);
      });
  };

  const sendRequestBTD = async (altbar, updateOrderItems) => {
    console.log(altbar);

    await backend
      .delete(`${API_URL}barcodealternates/${altbar}`)
      .then(({ data }) => {
        if (updateOrderItems) {
          setOrderItems((prevState) =>
            prevState.map((item) => {
              if (item.upc !== itemToLink.upc) return item;

              const barcodeIdentifiersMap = item.alternate_barcodes.filter(
                (abItem) => abItem !== altbar
              );

              return { ...item, alternate_barcodes: barcodeIdentifiersMap };
            })
          );
        }

        scanReset();
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo(error);
        // toggleResponseModal();
        setResponseModal(true);
      });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      sendRequest(true);
    }, 5000);

    return () => clearInterval(interval);
  }, [sendRequest]);

  useEffect(() => {
    if (imageInfo.name !== "A default product") {
      setImageModal((prevState) => !prevState);
    }
  }, [imageInfo]);

  useEffect(() => {
    const getOrderSubItems = async () => {
      const orderIdStr = orders.join("&order=");

      await backend
        .get(`${API_URL}ordersubitems?order=${orderIdStr}&no_page=1`)
        .then(({ data }) => {
          if (data.length) {
            setOrderSubItems(data);
          }
          setOrderSubItemsLoaded(true);
        });
    };

    const getOrderItems = async () => {
      const orderIdStr = orders.join("&order=");
      await backend
        .get(`${API_URL}orderitems?order=${orderIdStr}&no_page=1`)
        .then(({ data }) => {
          const dataMap = data.map((item) => ({ ...item, subitems: [] }));
          setOrderItems(dataMap);
        });
    };
    if (orders.length && !orderSubItems.length && !orderSubItemsLoaded) {
      getOrderSubItems();
    }
    if (orders.length && !orderItems.length && orderSubItemsLoaded) {
      getOrderItems();
    }
  }, [orders, orderItems, orderSubItems, orderSubItemsLoaded]);

  useEffect(() => {
    const getProducts = async () => {
      const orderItemsUPC = orderItems.map((item) => item.product);
      const orderItemsUPCUnique = [...new Set(orderItemsUPC)];

      const orderItemsUPCPag = paginate(orderItemsUPCUnique, 100);

      let productsArray = [];

      Promise.all(
        orderItemsUPCPag.map(async (pag) => {
          const productIdStr = pag.join("&upc=");

          await backend
            .get(
              `${API_URL}products?upc=${productIdStr}&include_inactive=true&include_nonprimary=true&no_page=1`
            )
            .then(({ data }) => {
              const dataMap = data.map((item) => ({
                ...item,
                unit_in_cart: 0,
                case_in_cart: 0,
                added_in_cart: false,
                added_through_sub: false,
              }));

              productsArray = [...productsArray, ...dataMap];
            });
        })
      ).then(() => {
        setProducts(productsArray);
      });
    };

    if (orderItems.length && !products.length && !orderItemsMapped) {
      getProducts();
    }
  }, [orderItems, orderItemsMapped, products]);

  useEffect(() => {
    const orderItemsMapping = () => {
      const dataMap = orderItems
        .map((item) => {
          const productData = products.find(
            (product) => product.upc === item.product
          );

          return {
            ...item,
            ...productData,
            item_codee: productData.item_code.item_code || "",
            coupon_amount: item.coupon_amount || 0,
            prototype_selected: false,
            subitems: orderSubItems.filter(
              (osiItem) => osiItem.order_item === item.id
            ),
            modified: false,
            new: false,
          };
        })
        .sort((a, b) => {
          if (isNaN(+a.bin) && isNaN(+b.bin)) {
            if (a.bin > b.bin) {
              return 1;
            }
            if (a.bin < b.bin) {
              return -1;
            }
            return 0;
          }

          if (isNaN(+a.bin)) return 1;
          if (isNaN(+b.bin)) return -1;

          if (+a.bin > +b.bin) {
            return 1;
          }
          if (+a.bin < +b.bin) {
            return -1;
          }
          return 0;
        });

      setOrderItems(dataMap);
      setOrderItemsMapped(true);
    };

    if (orderItems.length && products.length && !orderItemsMapped) {
      orderItemsMapping();
    }
  }, [orderItems, orderItemsMapped, orderSubItems, products]);

  useEffect(() => {
    setOrders(ordersState.map((item) => item.id));
  }, [ordersState]);

  // scanning logic
  useEffect(() => {
    const orderSearchBarcode = () => {
      // consider (think diff scenarios) using all barcode trims in an array for comparison with includes
      let barcodeTrims = [barcode];
      let orderItemsFound = orderItems.filter(
        (item) => `${item.upc}` === barcode
      );
      console.log(barcode, orderItemsFound);

      // todo: change to recursive function
      if (!orderItemsFound.length) {
        let barcodeModified = +barcode; // stripped leading 0s

        barcodeModified = barcodeModified
          .toString()
          .substring(0, barcodeModified.toString().length - 1);

        barcodeTrims.push(barcodeModified);

        orderItemsFound = orderItems.filter(
          (item) => item.upc === +barcodeModified
        );
        console.log(+barcodeModified, orderItemsFound);

        if (!orderItemsFound.length) {
          barcodeModified = barcodeModified
            .toString()
            .substring(1, barcodeModified.length); // stripping first digit of remaining barcodeF

          barcodeModified = +barcodeModified; // stripped leading 0s

          barcodeTrims.push(`${barcodeModified}`);

          orderItemsFound = orderItems.filter(
            (item) => item.upc === +barcodeModified
          );
          console.log(+barcodeModified, orderItemsFound);

          // loop orderitems and look up in the acceptable substitutions
          if (!orderItemsFound.length) {
            orderItemsFound = orderItems.filter((item) => {
              if (!item.acceptable_substitutions.length) return false;

              const asFound = item.acceptable_substitutions.find((asItem) =>
                barcodeTrims.includes(`${asItem.upc}`)
              );

              if (!asFound) return false;

              setItemToSwap(item);
              setAsItemsFound(asFound);
              return true;
            });
            console.log(barcodeTrims, orderItemsFound);

            // loop orderitems and look up in the barcode identifiers (alternatives)
            if (!orderItemsFound.length) {
              orderItemsFound = orderItems.filter((item) => {
                if (!item.alternate_barcodes.length) return false;

                return item.alternate_barcodes.includes(barcode);
              });
            }
            console.log(barcode, orderItemsFound);
          }
        }
      }

      orderItemsFound = orderItemsFound.map((item, index) => ({
        ...item,
        prototype_selected: index === 0,
      }));

      setOrderItemsMatched(orderItemsFound);
      setOrderItemsMatchedFinish(true);

      return orderItemsFound;
    };

    const getBarcodeInfo = async () => {
      await backend
        .get(`${API_URL}barcodealternates/${barcode}`)
        .then(({ data }) => {
          if (data) {
            setBarcodeInfo(data);
          }
        })
        .finally(() => {
          setBarcodeInfoLoaded(true);
        });
    };
    if (
      (barcodeScanned &&
        !["Not found", ""].includes(barcode) &&
        barcodeInfoLoaded &&
        orderItemsMapped) ||
      itemSwapped
    ) {
      orderSearchBarcode();
    }
    if (barcodeScanned && !barcodeInfoLoaded) {
      getBarcodeInfo();
    }
  }, [
    barcode,
    barcodeInfoLoaded,
    barcodeScanned,
    orderItems,
    orderItemsMapped,
    itemSwapped,
  ]);

  useEffect(() => {
    const asItemsFoundMapping = async () => {
      await backend
        .get(
          `${API_URL}products?upc=${asItemsFound.upc}&include_inactive=true&include_nonprimary=true&no_page=1`
        )
        .then(({ data }) => {
          if (data.length) {
            const dataMap = {
              ...data[0],
              unit_in_cart: 0,
              case_in_cart: 0,
              added_in_cart: false,
              added_through_sub: false,
              item_codee: data[0].item_code.item_code || "",
              coupon_amount: data[0].coupon_amount || 0,
            };
            setAsItemsFound(dataMap);
          }
        });
    };

    if (itemToSwap !== null && asItemsFound !== null) {
      if (!asItemsFound.hasOwnProperty("acceptable_substitutions")) {
        asItemsFoundMapping();
      }
    }
  }, [asItemsFound, itemToSwap]);

  return (
    <Container>
      <Dialog maxWidth="xs" open={imageModal} onClose={toggleImageModal}>
        {imageModalContent}
      </Dialog>
      <Dialog maxWidth="sm" open={scanDialog} onClose={toggleScanDialog}>
        {scanDialogContent}
      </Dialog>
      <Dialog maxWidth="xs" open={confirmModal} onClose={toggleConfirmModal}>
        {confirmModalContent}
      </Dialog>
      <Dialog maxWidth="xs" open={responseModal} onClose={toggleResponseModal}>
        {responseModalContent}
      </Dialog>
      <Typography variant="h6" component="div">
        Scan
      </Typography>
      <Typography variant="subtitle1">
        <strong>Start Date: </strong>
        {dateRangeState[0].toISOString().split("T")[0]}
      </Typography>
      <Typography variant="subtitle1">
        <strong>End Date: </strong>
        {dateRangeState[1].toISOString().split("T")[0]}
      </Typography>
      <Typography variant="subtitle1">
        <strong>Bulk Pull: </strong>
        {"" + bulkState}
      </Typography>
      <Typography variant="subtitle1">
        <strong>Included Orders: </strong>
        {orders.join(",")}
      </Typography>
      <Grid container spacing={2} style={{ marginBottom: 10 }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ textAlign: "center", alignItems: "center" }}
        >
          <Typography color="primary" variant="body2">
            There are <b>{!orderItems.length ? " no " : orderItems.length}</b>{" "}
            items in the included order
          </Typography>
          <Typography color="primary" variant="body2">
            <b>
              {
                orderItems.filter(
                  (item) => item.scanned || item.scanned === false
                ).length
              }
            </b>{" "}
            picked |{" "}
            <b>{orderItems.filter((item) => item.scanned === null).length}</b>{" "}
            left
          </Typography>
          <Button
            variant="contained"
            color="inherit"
            onClick={() => toggleShowPicked()}
          >
            {`${showPicked ? "Hide" : "Show"} picked`}
          </Button>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ textAlign: "right", alignItems: "center" }}
        >
          <IconButton onClick={handleChangeView}>
            <DashboardIcon className={view === 1 ? "activeView" : ""} />
          </IconButton>
          <IconButton onClick={handleChangeView}>
            <TableRowsIcon className={view === 2 ? "activeView" : ""} />
          </IconButton>
        </Grid>
      </Grid>
      {view === 1 ? (
        <Grid container spacing={2}>
          {orderItems.map((item, idx) => (
            <Fragment key={idx + "_container"}>
              <Grid
                item
                xs={12}
                sm={6}
                style={{
                  display:
                    (item.scanned === false || item.scanned) && !showPicked
                      ? "none"
                      : "block",
                }}
              >
                <Collapse
                  in={
                    showPicked ||
                    item.scanned === null ||
                    item.scanned === false
                  }
                >
                  <Card style={{ display: "flex" }}>
                    <CardMedia
                      style={{ width: 150 }}
                      component="img"
                      width="150"
                      height="150"
                      image={item.url}
                      alt={item.name}
                    />
                    <CardContent style={{ width: "100%" }}>
                      <div style={{ textAlign: "right" }}>
                        <IconButton onClick={() => handleChangeOIPos(item.upc)}>
                          <SavedSearchIcon />
                        </IconButton>
                        <Subitems
                          data={item}
                          handleSubitemsChange={handleSubitemsChange}
                        />
                        <Button
                          variant="contained"
                          size="small"
                          color={item.scanned === false ? "warning" : "inherit"}
                          onClick={() =>
                            handleChange({
                              target: {
                                name: `scanned-${idx}`,
                                checked: item.scanned === false ? null : false,
                              },
                            })
                          }
                        >
                          Scanned
                        </Button>
                        <Button
                          variant="contained"
                          size="small"
                          color={item.scanned ? "success" : "inherit"}
                          onClick={() =>
                            handleChange({
                              target: {
                                name: `scanned-${idx}`,
                                checked: item.scanned ? null : true,
                              },
                            })
                          }
                          style={{ marginLeft: 8 }}
                        >
                          Picked
                        </Button>
                      </div>
                      <Typography color="text.secondary">
                        <b>{`${item.upc}`}</b>
                      </Typography>
                      <Typography gutterBottom variant="h6" component="div">
                        {item.name}
                      </Typography>
                      <Typography
                        color="text.secondary"
                        style={{ marginBottom: "0.35em" }}
                      >
                        {`Bin: `}
                        <b>{`${item.bin}`}</b>
                      </Typography>
                      <Typography
                        color="text.secondary"
                        style={{ marginBottom: "0.35em" }}
                      >
                        {` Order: `}
                        <b>{`${item.order}`}</b>
                      </Typography>
                      <Typography
                        color="text.secondary"
                        style={{ marginBottom: "0.35em" }}
                      >
                        {` Inventory Stock: `}
                        <b>{`${item.stock_level || "N/A"}`}</b>
                      </Typography>
                      <Typography
                        color="text.secondary"
                        style={{ marginBottom: "0.35em" }}
                      >
                        {` Combined Stock: `}
                        <b>{`${item.combined_stock_level || "N/A"}`}</b>
                      </Typography>
                      <Typography color="text.secondary">
                        <b>{`${item.unit_quantity} of ${item.units_ordered}`}</b>
                        {` units needed`}
                      </Typography>
                      <Typography color="text.secondary">
                        <b>{`${item.case_quantity} of ${item.cases_ordered}`}</b>
                        {` cases needed`}
                      </Typography>
                    </CardContent>
                  </Card>
                  <Divider sx={{ margin: "10px 10px" }} />
                </Collapse>
              </Grid>
            </Fragment>
          ))}
        </Grid>
      ) : (
        orderItems.map((item, idx) => (
          <Fragment key={idx + "_container"}>
            {idx === 0 || idx % 10 === 0 ? (
              <>
                <Divider sx={{ margin: "10px 10px" }} />
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  textAlign="center"
                >
                  {columnsPrototype.map((column) => (
                    <Grid
                      item
                      xs={column.minWidth}
                      sm={column.minWidth}
                      key={`header-${column.id}`}
                    >
                      {column.label}
                    </Grid>
                  ))}
                </Grid>
              </>
            ) : (
              <></>
            )}
            <Collapse in={showPicked || item.scanned === null}>
              <Divider sx={{ margin: "10px 10px" }} />
              <Grid
                container
                className={`${
                  itemFound && itemFound.upc === item.upc ? "rowHighlight" : ""
                }`}
                spacing={2}
                alignItems="center"
                textAlign="center"
              >
                {columnsPrototype.map((column) => {
                  const value = item[column.id];

                  const checkValue =
                    column.id === "scanned" && item.scanned === false
                      ? true
                      : column.id === "picked" && item.scanned
                      ? true
                      : false;

                  return (
                    <Grid
                      item
                      xs={column.minWidth}
                      sm={column.minWidth}
                      key={`row-${idx}-column-${column.id}`}
                    >
                      {column.exposed
                        ? {
                            checkbox: (
                              <Checkbox
                                name={`${column.id}-${idx}`}
                                value={checkValue}
                                checked={checkValue}
                                onChange={handleChange}
                              />
                            ),
                          }[column.exposedAs]
                        : typeof value === "boolean"
                        ? "" + value
                        : typeof value === "string" &&
                          (value.indexOf("https://") === 0 ||
                            value.indexOf("http://") === 0)
                        ? getImageComponent(column, item)
                        : column.id === "url"
                        ? "N/A"
                        : value || 0}
                    </Grid>
                  );
                })}
              </Grid>
            </Collapse>
          </Fragment>
        ))
      )}
      {orderItems.length ? (
        <>
          <Stack
            direction="column"
            spacing={2}
            sx={{ position: "fixed", bottom: 10, right: 10 }}
          >
            {isSaving || !orderItemsMapped ? (
              <Fab
                color="default"
                aria-label="save"
                title="Loading | Saving in process"
              >
                <CircularProgress />
              </Fab>
            ) : (
              <Fab aria-label="save" title="Saved">
                <CheckIcon color="success" />
              </Fab>
            )}
            <Fab
              color="primary"
              onClick={toggleScanDialog}
              aria-label="scan"
              title="Scan"
            >
              <QrCodeScannerIcon />
            </Fab>
            <Fab
              color="success"
              onClick={toggleConfirmModal}
              aria-label="save"
              title="Save"
            >
              <SaveIcon />
            </Fab>
          </Stack>
        </>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default Prototype;
